import { render } from "./vcompanyedit.vue?vue&type=template&id=5006c28e&scoped=true"
import script from "./vcompanyedit.vue?vue&type=script&lang=js"
export * from "./vcompanyedit.vue?vue&type=script&lang=js"

import "./vcompanyedit.vue?vue&type=style&index=0&id=5006c28e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5006c28e"]])

export default __exports__